import React, { useEffect, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";

import { ReactComponent as CrosIconCustHome } from "../../assets/images/crosIconCustHome.svg";
import { ReactComponent as Accordion } from "../../assets/images/accordion.svg";
import { object } from "yup";
import {
  useCustomerTableMutation,
  useCustomerTableNodeQuery,
  useFetchCustomerTableDataMutation,
  useLazyCustomerTableNodeQuery,
} from "../../utils/customer/customerTable";
import { parseJSONValue } from "../../utils/json/parseJSONValue";
import BasicSelect from "../Task/BasicSelect";
import { getCompanyId, getOrganizationId, getUserToken } from "../../utils/utilityFunctions/localServices";

import { pushAlert } from "../../utils/alertSlice";
import { useDispatch, useSelector } from "react-redux";
import { useGroupAddUpdateNodeMutation } from "../../utils/customer/groups";

const AddGroupDrawer = ({ open, onClose, groupEditData, setGroupEditData, refetch, anchorParentRef }) => {
  const defaultGroupData = {
    group: "",
    group_display_name: "",
    client_type: "",
    group_code: "",
    country_id: "",
    website: "",
    phone: "",
    email: "",
  };
  const dispatch = useDispatch();

  const [groupFormData, setGroupFormData] = useState(defaultGroupData);
  const [errors, setErrors] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [industry, setIndustry] = useState([]);

  const [CustomerTableDrop, { data: customerCommnData }] = useCustomerTableMutation();

  const [IndustryDropdownData, { data: industryData }] = useLazyCustomerTableNodeQuery();

  const parsedData = Array.isArray(parseJSONValue(customerCommnData?.data))
    ? parseJSONValue(customerCommnData?.data)
    : [];

  const [groupAddUpdateNode, { data, error, isLoading, isSuccess }] = useGroupAddUpdateNodeMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGroupFormData({ ...groupFormData, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    const mandatoryFields = [
      "group",
      "group_display_name",
      // "group_code",
      "client_type",
      // "country_id",
      "phone",
      "email",
    ];

    mandatoryFields.forEach((key) => {
      const value = groupFormData[key];
      if (!value?.toString().trim()) {
        newErrors[key] = "This field is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    console.log("inside handleSubmit");

    if (!validateForm()) return;
    try {
      console.log("inside try");

      const response = await groupAddUpdateNode({
        token: getUserToken(),
        data: {
          org_id: getOrganizationId(),
          company_id: getCompanyId(),
          customer_name: groupFormData?.group,
          customer_display_name: groupFormData?.group_display_name,
          customer_code: groupFormData?.group_code,
          type: groupFormData?.client_type,
          website: groupFormData?.website,
          country_id: groupFormData?.country_id,
          phone: groupFormData?.phone,
          email: groupFormData?.email,
          ...(groupEditData?.customerData?.customer_group_id && { id: groupEditData?.customerData.customer_group_id }),
        },
      }).unwrap();
      console.log("inside try response", response);
      onClose();
      refetch();

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Updated Successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Entry Error",
            type: "danger",
          })
        );
      }
    } catch (err) {
      console.error("inside Submission failed:", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const typeResponse = await IndustryDropdownData({
          token: getUserToken(),
          orgId: getOrganizationId(),
          companyId: getCompanyId(),
          fieldName: "business_category",
        }).unwrap();

        console.log(typeResponse, "typeResponse aakash");
        const parsedType = Array.isArray(parseJSONValue(typeResponse?.data)) ? parseJSONValue(typeResponse?.data) : [];

        setTypeData(parsedType);
      } catch (error) {
        console.error("Failed to fetch type data:", error);
        setTypeData([]);
      }
      // const typePayload = {
      //   model_name: "customers",
      //   field_name: "type",
      // };

      try {
        const countryPayload = {
          model_name: "customers",
          field_name: "country_id",
        };
        const countryResponse = await CustomerTableDrop({
          token: getUserToken(),
          data: countryPayload,
        }).unwrap();

        const parsedCountry = Array.isArray(parseJSONValue(countryResponse?.data))
          ? parseJSONValue(countryResponse?.data)
          : [];

        setCountryData(parsedCountry);
      } catch (error) {
        setCountryData([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Object.keys(groupEditData).length) {
      console.log("groupEditData", groupEditData);

      setGroupFormData((prev) => ({
        ...prev,
        group: groupEditData?.customerData.customer_group,
        group_display_name: groupEditData?.customerData?.customer_display_name,
        client_type: groupEditData?.customerData?.type,
        group_code: groupEditData?.customerData?.customer_code,
        country_id: groupEditData?.customerData?.country_id,
        website: groupEditData?.customerData?.website,
        phone: groupEditData?.customerData?.phone,
        email: groupEditData?.customerData?.email,
      }));
    }
  }, [groupEditData]);

  console.log(groupEditData.customerData, "groupeditdata");
  console.log(errors, "errors");

  return (
    <CustomDrawer open={open} onClose={onClose} parallelDrawer anchorParentRef={anchorParentRef}>
      <div className="w-full h-full flex flex-col bg-white">
        <div className="px-4 py-3 flex justify-between items-center border-b border-[#BECBD3] ">
          <div className="text-[#434852] font-[Poppins] text-[16px] font-medium ">
            {Object.keys(groupEditData).length ? "Edit Group" : "Add Group"}
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              onClose();
              setGroupFormData(defaultGroupData);
            }}
          >
            <CrosIconCustHome className=" text-[#B9B9B9] font-9xl w-3 h-3 " />
          </div>
        </div>
        <div className="min-h-0 grow flex flex-col justify-between pb-5">
          <div className="mt-2">
            <div className="flex flex-col gap-4">
              <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Group<span className="text-red-700">* </span>
                  {/* {errors && <span className="text-red-700"> {errors.customer_display_name}</span>} */}
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.group}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.group}
                  id={`group`}
                  name="group"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Detail`}
                />
              </div>
              <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Grp. Display Name<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.group_display_name}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.group_display_name}
                  id={`group_display_name`}
                  name="group_display_name"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Group Display Name`}
                />
              </div>
              <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Business Category<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.client_type}</span>}
                </label>
                <BasicSelect
                  options={typeData?.map((option) => ({
                    label: option?.value,
                    value: option?.value,
                  }))}
                  inputBoxSize="medium"
                  name={"client_type"}
                  label={"Type"}
                  onChange={handleInputChange}
                  value={groupFormData?.client_type}
                  showSearch
                />
              </div>
              {/* commented the group_code field as per the requirement */}
              {/* <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Grp. Code<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.group_code}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.group_code}
                  id={`group_code`}
                  name="group_code"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Group Code`}
                />
              </div> */}
              <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Website
                  {errors && <span className="text-red-700 text-xs ml-1"> {errors.website}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.website}
                  id={`website`}
                  name="website"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Website`}
                />
              </div>
              <div className="px-3">
                <label htmlFor={`country_id`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Country
                  {/* <span className="text-red-700">* </span> */}
                  {errors && <span className="text-red-700 text-xs ml-1"> {errors.country_id}</span>}
                </label>
                <BasicSelect
                  options={countryData?.map((option) => ({
                    label: option?.value,
                    value: option?.value,
                  }))}
                  inputBoxSize="medium"
                  name={"country_id"}
                  label={"country"}
                  onChange={handleInputChange}
                  value={groupFormData?.country_id}
                  showSearch
                />
              </div>
              <div className="px-3">
                <label htmlFor={`phone`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Phone<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.phone}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.phone}
                  id={`phone`}
                  name="phone"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Phone`}
                />
              </div>
              <div className="px-3">
                <label htmlFor={`email`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Email<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700 text-xs ml-1">{errors.email}</span>}
                </label>
                <input
                  type={`text`}
                  value={groupFormData?.email}
                  id={`email`}
                  name="email"
                  onChange={handleInputChange}
                  // onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Email`}
                />
              </div>
            </div>
          </div>
          <div className={`flex justify-end text-md w-full border-t border-BECBD3 pt-3 px-3`}>
            <button
              onClick={() => {
                setGroupFormData(defaultGroupData);
                onClose();
              }}
              type={`button`}
              className={`px-6 py-1 text-16  rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2`}
            >
              CANCEL
            </button>
            <button
              onClick={handleSubmit}
              className="px-6 py-1 text-16 rounded-5px font-500 bg-1D4469 text-white focus:outline-none cbtn-transition-bg "
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default AddGroupDrawer;
